import React from 'react';

import Button, { type ButtonProps } from '../Button';
import Loader from '../Loader';

export interface SubmitButtonProps extends ButtonProps {
  submitting?: boolean;
}

export function SubmitButton({ submitting, ...props }: SubmitButtonProps) {
  return (
    <Button {...props} type="submit">
      {submitting ? <Loader /> : props.children}
    </Button>
  );
}
